import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

const WhatsAppPreview = styled(Box)(({ theme }) => ({
  backgroundColor: '#25D366',
  color: 'white',
  padding: theme.spacing(2),
  borderRadius: '18px 18px 18px 4px',
  maxWidth: '80%',
  marginBottom: theme.spacing(1),
  position: 'relative',
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: -8,
    width: 0,
    height: 0,
    border: '8px solid transparent',
    borderTopColor: '#25D366',
    borderBottom: 0,
    borderRight: 0,
  },
}));

const UserPreview = styled(Box)(({ theme }) => ({
  backgroundColor: '#E8E8E8',
  color: '#000',
  padding: theme.spacing(2),
  borderRadius: '18px 18px 4px 18px',
  maxWidth: '80%',
  marginLeft: 'auto',
  marginBottom: theme.spacing(1),
  position: 'relative',
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    right: -8,
    width: 0,
    height: 0,
    border: '8px solid transparent',
    borderTopColor: '#E8E8E8',
    borderBottom: 0,
    borderLeft: 0,
  },
}));

const SurveyPreview = ({ open, onClose, survey }) => {
  if (!survey) return null;

  const getTypeText = type => {
    return type === 'rating' ? 'Calificación' : 'Texto';
  };

  const renderPreview = () => {
    return (
      <Box sx={{ p: 2 }}>
        <Typography variant="h6" sx={{ mb: 2, textAlign: 'center' }}>
          Vista previa de la encuesta
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {/* Bot message */}
          <WhatsAppPreview>
            <Typography variant="body1">{survey.question}</Typography>
          </WhatsAppPreview>

          {/* User response preview */}
          <UserPreview>
            {survey.type === 'rating' ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="body2">{survey.max_rating}</Typography>
              </Box>
            ) : (
              <Typography variant="body2">
                ("Respuesta ingresada por el usuario")
              </Typography>
            )}
          </UserPreview>
        </Box>

        <Box sx={{ mt: 2, p: 2, backgroundColor: 'white', borderRadius: 1 }}>
          <Typography variant="body2" color="text.secondary">
            <strong>Tipo:</strong> {getTypeText(survey.type)}
          </Typography>
          {survey.type === 'rating' && (
            <Typography variant="body2" color="text.secondary">
              <strong>Escala:</strong> 1 a {survey.max_rating} estrellas
            </Typography>
          )}
        </Box>
      </Box>
    );
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Encuesta de Satisfacción</DialogTitle>
      <DialogContent>{renderPreview()}</DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SurveyPreview;
